import CardCommon from '@op/components/CardCommon';
import { tableIcon, lineIcon, barIcon } from '@op/constants/chart';
import React, { useState } from 'react';
import { useIntl } from 'umi';
import PRTable from './PRTable';
import PRCharts from './PRCharts';
import { SortBy } from 'tea-component/lib/table/addons';
import { useDownloadParams } from '@op/hooks/useDownloadParams';

export default function PR({
  filter,
  gameData,
  wholeGameInfo,
}: {
  filter: any;
  gameData: any;
  wholeGameInfo: any;
}) {
  const [chartType, setChartType] = useState('bar');
  const [sortBy, setSortBy] = useState<SortBy<any>>({
    by: 'time',
    order: 'desc',
  });

  const { downloadLegacy, downloading } = useDownloadParams();

  return (
    <CardCommon
      id="PR"
      className="scroll-margin-top-target"
      title={'PR'}
      hasDownload
      downloadLoading={downloading}
      operations={[tableIcon, lineIcon, barIcon]}
      defaultOperation={chartType}
      handleOperationsOnClick={(item) => {
        setChartType(item?.symbol || 'bar');
      }}
      handleDownloadOnClick={() => {
        const downloadLimit = 10000;
        const params = {
          page: 1,
          page_size: 1000,
          noChangePageSize: true,
          stats_types: ['pr'],
          tab_type: 'pr',
          sort: sortBy,
        };
        const downLoadParams = {
          ...filter,
          ...params,
          gameData,
        };
        const gameName = wholeGameInfo?.entity_name || '';
        const fileName = `${gameName} Compare Key Metrics - DataBrain Opinions`;
        downloadLegacy({
          total: downloadLimit,
          limit: downloadLimit,
          fileName,
          params: downLoadParams,
          downloadFunc: 'getCompareKeyMetrics',
          sheetName: 'PR',
        });
      }}
      logBtnId="PR"
    >
      <PRCharts
        filter={filter}
        gameData={gameData}
        chartType={chartType}
        sortBy={sortBy}
        setSorts={setSortBy}
      />
      <PRTable filter={filter} gameData={gameData}></PRTable>
    </CardCommon>
  );
}
